import React from 'react'
import Icon from '@/components/Icon'

const Spinner = ({ visible }) => (visible ? <Icon name="spinner" /> : null)

export default Spinner
